export type WeightedField<T> = [T, number];

export default class ArrayUtils {
	//Fisher-Yates Shuffle
	static shuffle<T>(array: Array<T>): Array<T> {
		let currentIndex = array.length;
		let temporaryValue;
		let randomIndex;

		while (0 !== currentIndex) {
			randomIndex = Math.floor(Math.random() * currentIndex);
			currentIndex -= 1;

			temporaryValue = array[currentIndex];
			array[currentIndex] = array[randomIndex];
			array[randomIndex] = temporaryValue;
		}
		return array;
	}

	static remove<T>(array: Array<T>, item: T): Array<T> {
		for (let i = 0; i < array.length; i++) {
			if (array[i] == item) {
				return array.splice(i, 1);
			}
		}
		return array;
	}

	static clone<T>(array: Array<T>): Array<T> {
		const clone: Array<T> = new Array<T>();
		for (let i = 0; i < array.length; i++) {
			clone.push(array[i]);
		}
		return clone;
	}

	static weightedRandom<T>(fields: WeightedField<T>[], rnd: Phaser.Math.RandomDataGenerator): T {
		let total = 0;
		for (const field of fields) total += field[1];
		let rand = rnd.realInRange(0, total);
		for (const field of fields) {
			rand -= field[1];
			if (rand <= 0) return field[0];
		}
	}
}
